import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getBlockDepth from '../../utils/getBlockDepth';
var MAX_DEPTH = 7;

var computeDepth = function computeDepth(block) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var depth = getBlockDepth(block);
  return Math.min(Math.max(depth + direction, 0), MAX_DEPTH);
};

export default function changeDepth(editor, direction) {
  var selection = editor.value.selection;
  var blocks = editor.value.document.getLeafBlocksAtRange(selection);
  return blocks.reduce(function (memo, block) {
    if (!editor.canChangeDepth(block)) {
      return memo;
    }

    return memo.setNodeByKey(block.key, {
      data: _objectSpread({}, block.data.toJS(), {
        depth: computeDepth(block, direction)
      })
    });
  }, editor);
}